import React, { Component } from 'react';
import Helmet from "react-helmet";
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import Cardsall from '../../components/toto/cardsall';

// @inject('lineStore')
// @withRouter
export default class CardsallPage extends Component { 
	render() {
			return(
				<div className="toto-page">
					<Helmet>
						<title>ИРМ - Список карточек тотализатора</title>
					</Helmet>
					<div className="toto-page__body">
						<Cardsall />
					</div>
				</div> 
			)
	}
}


// WEBPACK FOOTER //
// ./src/routes/toto/cardsall.jsx